import { type FC } from 'react';

import { useExpireContractTimer } from '@/common/hooks/contract/expire-contract-time';
import { useTimerToSpecContractOpeningEnd } from '@/common/hooks/timer-to-spec-contract-opening-end';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { ShortTimerUi } from '@/components/ui/ShortTimer/ShortTimer';

interface ContractTimerProps {
  kind: SpecContractType | PaidSpecContractType;
  isExtendsTimer?: boolean;
}

const OpenContractTimer: FC<ContractTimerProps> = ({
  kind,
  isExtendsTimer,
}) => {
  const timeToOpenStatusEnd = useTimerToSpecContractOpeningEnd(kind);
  const timeToEpiredStatusEnd = useExpireContractTimer(kind);

  return (
    <ShortTimerUi
      className="mt-6"
      timeLeft={
        isExtendsTimer ? timeToEpiredStatusEnd || 0 : timeToOpenStatusEnd || 0
      }
    />
  );
};

export { OpenContractTimer };
